/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_BookInputs */

const en_coaching_book = /** @type {(inputs: Coaching_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book a session`)
};

const id_coaching_book = /** @type {(inputs: Coaching_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan sesi`)
};

/**
* | output |
* | --- |
* | "Book a session" |
*
* @param {Coaching_BookInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_book = /** @type {((inputs?: Coaching_BookInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_BookInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_book(inputs)
	return en_coaching_book(inputs)
});